import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { usersControllerListPending } from '../../../../api/generated';
import { pendingCountQueryKey } from '../../../../api/pending';
import { ModerationTab } from '../../../../components/admin/ModerationTab';

export const Route = createFileRoute('/_auth/photos/moderation/')({
  component: ModerationPage,
});

function ModerationPage() {
  const { t } = useTranslation();
  const { data: pending } = useQuery({
    queryKey: pendingCountQueryKey,
    queryFn: async () => {
      const { data } = await usersControllerListPending({
        throwOnError: true,
      });
      return data;
    },
    staleTime: 30_000,
  });
  const count = pending?.length ?? 0;
  return (
    <section className="epi-card tone-blue">
      <div className="epi-card-head">
        <span className="num">M</span>
        <span className="title">
          {t('photosModerationPage.title', "File d'attente")}
        </span>
        <span className="meta">
          {count > 0
            ? t('photosModerationPage.metaCount', '{{count}} EN ATTENTE', {
                count,
              })
            : t('photosModerationPage.metaIdle', 'À JOUR')}
        </span>
      </div>
      <ModerationTab />
    </section>
  );
}
